import { render, staticRenderFns } from "./BloodCreation.vue?vue&type=template&id=04010412&scoped=true"
import script from "./BloodCreation.vue?vue&type=script&lang=js"
export * from "./BloodCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04010412",
  null
  
)

export default component.exports